import React from 'react';
import { pricesWrapper } from './styles';
import type { ProductPriceToDisplayProps } from 'common/components/product-card/types';
import { useProductPrice } from 'common/components/product-card/use-product-price';
import { PriceBlock } from 'fronton-react';

export const SponsoredProductPriceToDisplay: React.FC<ProductPriceToDisplayProps> = ({
  hasOldPrice,
  price,
  productPriceCategory,
}) => {
  const { mainPrice, units, discount, unitUnits, type } = useProductPrice({
    hasOldPrice,
    price,
    productPriceCategory,
  });

  return (
    <div className={pricesWrapper}>
      <PriceBlock
        price={mainPrice}
        units={units}
        unitUnits={unitUnits}
        unitPrice={price.additional_price}
        discount={discount}
        oldPrice={price.previous_price ?? undefined}
        type={type}
        size="s"
        direction="vertical"
      />
    </div>
  );
};
